import React from 'react';

import { Alert, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { BulkPatchPropertyCommitRow, BulkPatchPropertyField } from '~/services/BedbankService';

const PATCH_FIELDS: Array<BulkPatchPropertyField> = ['status', 'domain', 'airport'];

function renderCommitValue(row: BulkPatchPropertyCommitRow, field: BulkPatchPropertyField) {
  if (typeof row[field] === 'undefined') {
    return '-';
  }

  return row[field] ?? 'null';
}

interface Props {
  rows: Array<BulkPatchPropertyCommitRow>;
}

export default function BulkPropertyUpdateCommitTable({ rows }: Props) {
  if (rows.length === 0) {
    return <Alert severity="info">Committed rows will display here.</Alert>;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Property ID</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Domain</TableCell>
          <TableCell>Airport</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.id}>
            <TableCell>{row.id}</TableCell>
            {PATCH_FIELDS.map((field) => (
              <TableCell key={field}>{renderCommitValue(row, field)}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
